module.exports = __webpack_public_path__ + "documents/VZPH_Fios_Terms_of_Service.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VZPH_Fios_Terms_of_Service.pdf
// module id = 3532
// module chunks = 0